import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLang } from '../LangContext';

const SITE_URL = 'https://horrenmaker.nl';
const SITE_NAME = 'Horrenmaker.nl';
const DEFAULT_OG_IMAGE = '/scenes/hero-summer.png';

export default function Seo({ title, description, path, image = DEFAULT_OG_IMAGE, lang = 'nl', noindex = false }) {
  const ctx = useLang();
  const effectivePath = normalizePath(path || (typeof window !== 'undefined' ? window.location.pathname : '/'));
  const override = ctx?.overlay?.seo?.[effectivePath]?.[lang] || {};
  const pageTitle = override.title || title;
  const pageDescription = override.description || description;
  const pageImage = override.image || image || DEFAULT_OG_IMAGE;
  const pageNoindex = override.noindex === true || noindex;
  const fullTitle = pageTitle ? `${pageTitle} - ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${effectivePath}`;
  const ogLocale = lang === 'de' ? 'de_DE' : 'nl_NL';
  const ogImage = pageImage.startsWith('http') ? pageImage : `${SITE_URL}${pageImage}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      {pageDescription && <meta name="description" content={pageDescription} />}
      <link rel="canonical" href={url} />
      {pageNoindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {pageDescription && <meta property="og:description" content={pageDescription} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={ogLocale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {pageDescription && <meta name="twitter:description" content={pageDescription} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}

function normalizePath(path) {
  if (!path) return '/';
  const raw = String(path).split('?')[0].split('#')[0] || '/';
  const withSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : '/';
}
